import { Verdict } from '@exam-management/graphql';
import { z } from 'zod';

export default function getReviewResultFormSchema() {
  return z.object({
    verdict: z.enum([Verdict.Approved, Verdict.Rejected]).optional(),
  });
}
